<template>
  <b-row>
    <b-col xs="12" sm="12" md="5" class="mr-4">
        <base-select class="dropdown" v-model="specialties.selected" valueProp="value" :options="specialties.options"
        :placeholder="$t('specialties')"></base-select>
    </b-col>
    <b-col xs="12" sm="12" md="5" class="mr-4">
        <base-select v-if="localServices.options" class="dropdown"
        v-model="localServices.selected" valueProp="value" :options="localServices.options"
        :placeholder="$t('services')"></base-select>
    </b-col>
    <b-col xs="12" sm="12" md="10" lg="10" v-if="showInsurances" class="mr-4">
        <base-select class="dropdown" v-model="insurers.selected" valueProp="name" label="name" :options="insurers.options"
        :placeholder="$t('insurances')"></base-select>
    </b-col>

    <b-col xs="2" sm="2" md="2" lg="2" style="margin-right:-3.5rem !important">
        <base-button style="height:2.8rem" blue @click="() => { doSearch() }">
        <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white" />
        </base-button>
    </b-col>
    </b-row>
</template>

<script>
// Hay que internacionalizar el texto de los servicios

const CONSULTATION_TYPES_OPTIONS = [
    {
      value: 'inplace',
      label: 'Consulta'
    },
    {
      value: 'online',
      label: 'Videoconsulta Programada'
    },
    {
      value: 'chat',
      label: 'Chat'
    },
    {
      value: 'webmail',
      label: 'Consulta Escrita'
    },
     {
      value: 'inmediate',
      label: 'Videoconsulta Inmediata'
    },
     {
      value: 'consultationAway',
      label: 'Consulta a Domicilio'
    },
     {
      value: 'secondOpinion',
      label: 'Segunda Opinión'
    },
    {
      value: 'servicesPackages',
      label: 'Paquetes de Servicio'
    },
    {
      value: 'flatRateWebmail',
      label: 'Tarifa Plana Consulta Escrita y Chat'
    }
]

export default {
    name: 'LandingSearchSelectors',
    props: {
        showInsurances: {
            type: Boolean,
            default: false
        },
        services: {
            type: Array,
            default: CONSULTATION_TYPES_OPTIONS
        }
    },
    mounted () {
        this.$api.get('/Specialties/GetSpecialitiesByProf').then((response) => {
            this.specialties.options = response.data
        })
        if (this.showInsurances) {
            this.$api.get('/insurers').then((response) => {
                this.insurers.options = response.data
            })
        }
    },
    data () {
        return {
            specialties: {
                selected: null,
                options: []
            },
            localServices: {
                selected: null,
                options: this.services
            },
            insurers: {
                selected: null,
                options: []
            }
        }
    },
    doSearch () {
        window.location = this.$helpers.getAppUrl(`Account/Login?ReturnUrl=%2Fes%2FHomePaciente%2FIndex%2F#/search?speciality=${this.specialty}&location=null&insurance=null&${this.services.selected}=true&subspeciality=null&query=&coordinateX=-5.9938442&coordinateY=37.3698465&disease=null`)
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/public/LandingSearchSelectors.vue